<template>
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.81565 11.9504V7.05116M8.696 11.9504V7.05116M11.5763 11.9504V7.05116M0.775042 14.75H13.7366M2.9353 11.9504V7.05116M6.62215 0.890691C6.81974 0.797402 7.03666 0.74928 7.25633 0.750008C7.47599 0.750736 7.69257 0.800294 7.8895 0.89489L13.5537 3.58738C13.8965 3.75046 13.7769 4.25158 13.3953 4.25158H1.11636C0.734717 4.25158 0.615902 3.75046 0.957944 3.58738L6.62215 0.890691Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<script>
export default {
  name: 'BankIcon',
}
</script>
